import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation, useHistory } from 'react-router-dom'
import { FacebookEmbed, InstagramEmbed } from 'react-social-media-embed'
import {
  Box,
  // AppBar,
  // Toolbar,
  Grid,
  Button,
  Divider,
  Typography,
} from '@material-ui/core'
import useViewArticlePageStyles from './ViewArticlePageStyles'
import { addProfileLogEvent } from '../../../dashboard/widgets/MyProfile/myProfileSlice'
import { handleEpochDate } from '../../helpers'
import BackButtonNavBar from '../../../../CommonComponents/BackButtonNavBar/BackButtonNavBar'
import CheckIsMobile from '../../../../../utils/isMobileHook'
import { fetchNews } from '../../newsSlice'

function ViewArticlePage() {
  const classes = useViewArticlePageStyles()
  const dispatch = useDispatch()
  const location = useLocation()
  const isMobile = CheckIsMobile()
  const history = useHistory()
  const { newsStatus, allArticles } = useSelector((s) => s.news)
  const [article, setArticle] = React.useState({
    id: '',
    author: '',
    sourceEntryId: '',
    pubDate: { seconds: 0 },
    imageUrl: '',
    description: '',
  })

  React.useEffect(() => {
    createPage()
  }, [newsStatus])

  React.useEffect(() => {
    const query = location.search.concat(location.hash)
    if (allArticles) {
      const selectedNewsArticle = allArticles?.filter((c) => {
        const selectedArticle =
          c.id?.trim() === decodeURIComponent(query?.slice(8)).trim() ||
          c.id?.trim().replace(/\n/g, '') ===
            decodeURIComponent(query?.slice(8)).trim()
        return selectedArticle
      })[0]
      //   if (article !== selectedNewsArticle) {
      setArticle(selectedNewsArticle)
      //   }
    }
  }, [])

  const createPage = () => {
    if (newsStatus === 'idle' || newsStatus === 'pending') {
      const fetchData = async () => {
        try {
          await dispatch(fetchNews())
        } catch (error) {
          // Handle any potential error here
          console.error('Error fetching news:', error)
        }
      }
      fetchData()
    } else {
      const query = location.search.concat(location.hash)
      if (allArticles) {
        const selectedNewsArticle = allArticles?.filter((c) => {
          const selectedArticle =
            c.id?.trim() === decodeURIComponent(query?.slice(8)).trim() ||
            c.id?.trim().replace(/\n/g, '') ===
              decodeURIComponent(query?.slice(8)).trim()
          return selectedArticle
        })[0]
        // if (article !== selectedNewsArticle) {
        setArticle(selectedNewsArticle)
        // }
      }
    }
  }

  const learnMoreHandler = () => {
    if (process.env.REACT_APP_FIREBASE_ON === 'true') {
      dispatch(
        addProfileLogEvent({
          module: 'News',
          object: 'Articles',
          objectId: encodeURIComponent(article.id),
          action: 'Click',
          actionContext: 'ReadMore',
          actionContextValue: '',
          rcpid: localStorage.getItem('rutgersEduRCPID'),
          url: article.url,
          timestamp: Date.now(),
        }),
      )
    }
    window.open(article.url, '_blank')
  }

  const renderDescription = (articleObj) => {
    console.log('render description called ', articleObj)
    if (articleObj?.url?.toLowerCase().includes('facebook')) {
      // Handle the case where 'Facebook' is in the sourceName
      return (
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <FacebookEmbed url={articleObj.url} width={isMobile ? null : 550} />
        </div>
      )
    }
    if (articleObj?.url?.toLowerCase().includes('instagram')) {
      return (
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <InstagramEmbed url={articleObj.url} width={isMobile ? null : 550} />
        </div>
      )
    }
    return (
      <Typography variant="body1" className={classes.description}>
        {article?.description?.replace(/<([^>]+?)([^>]*?)>(.*?)/gi, '')}
      </Typography>
    )
  }

  return (
    <div id="main-content">
      {isMobile ? (
        <BackButtonNavBar
          onClick={() => {
            history.goBack()
          }}
          name={article?.sourceEntryId || 'News'}
        />
      ) : (
        <div
          style={{
            overflowX: 'hidden',
            width: '100%',
            paddingTop: '60px',
            paddingLeft: '55px',
          }}
        >
          <BackButtonNavBar
            onClick={() => {
              history.goBack()
            }}
            name={article?.sourceEntryId || 'News'}
            topMargin={{ xs: 0, sm: 0, md: 64, lg: 64 }}
          />
        </div>
      )}
      <Grid
        container
        justifyContent="center"
        className={classes.articleContainer}
      >
        <Grid item>
          <Box className={classes.container}>
            <Grid
              container
              direction="row"
              justifyContent="space-between"
              className={classes.articleDetailsContainer}
            >
              <Grid item>
                {article?.author ? (
                  <Typography variant="caption" className={classes.author}>
                    By {article.author}
                  </Typography>
                ) : (
                  <Typography
                    variant="caption"
                    className={classes.articleSourceText}
                  >
                    {article?.sourceEntryId}
                  </Typography>
                )}
              </Grid>
              <Grid item>
                <Typography variant="caption" className={classes.publishedDate}>
                  {handleEpochDate(article?.pubDate?.seconds)}
                </Typography>
              </Grid>
            </Grid>
            <Grid item className={classes.imageGridItem}>
              {article?.imageUrl && article?.tag !== 'social' ? (
                <img className={classes.image} src={article?.imageUrl} alt="" />
              ) : (
                <Divider className={classes.divider} />
              )}
            </Grid>
            <Grid item> {renderDescription(article)} </Grid>
            <Grid item>
              <Button
                className={classes.learnMoreButton}
                onClick={learnMoreHandler}
              >
                Read More
              </Button>
            </Grid>
          </Box>
        </Grid>
      </Grid>
    </div>
  )
}

export default ViewArticlePage
